import { Button, Modal } from '@dev-spendesk/grapes';
import { type Dispatch } from 'react';

import { type AccountingSoftware } from 'modules/bookkeep/integration/status';
import { useTranslation } from 'src/core/common/hooks/useTranslation';

import { type ModalState } from './ModalState';
import { type AnalyticalFieldMappingDelete } from '../../../../../hooks/useCreateAnalyticalFieldMappingMutation';

interface Props {
  integration: AccountingSoftware;
  modalState: ModalState;
  setModalState: Dispatch<ModalState>;
  onDelete: (
    editedAnalyticalField: AnalyticalFieldMappingDelete & {
      externalName: string;
    },
  ) => void;
}

export const PullAndMapWithValuesDeleteModal = ({
  integration,
  modalState,
  setModalState,
  onDelete,
}: Props) => {
  const { t } = useTranslation('global');

  return (
    <Modal
      actions={[
        <Button
          key="no"
          onClick={() => setModalState({ modalKind: 'closed' })}
          text={t('misc.cancel')}
          variant="secondaryNeutral"
        />,
        <Button
          key="yes"
          text={t(
            'bookkeep.integrations.settings.analyticalFieldsMappingsTable.deleteAnalyticalFieldMapping.confirmDeletion',
          )}
          variant="primaryBrand"
          onClick={() => {
            if (modalState.modalKind === 'delete') {
              onDelete(modalState);
            }
            setModalState({ modalKind: 'closed' });
          }}
        />,
      ]}
      onClose={() => {
        setModalState({ modalKind: 'closed' });
      }}
      iconName="trash"
      title={t(
        'bookkeep.integrations.settings.analyticalFieldsMappingsTable.deleteAnalyticalFieldMapping.title',
        {
          externalName:
            modalState.modalKind === 'delete' && modalState.externalName,
        },
      )}
      subtitle={t(
        'bookkeep.integrations.settings.analyticalFieldsMappingsTable.deleteAnalyticalFieldMapping.subtitle',
        {
          integration,
        },
      )}
      iconVariant="alert"
      isOpen={modalState.modalKind === 'delete'}
    />
  );
};
